<div class="p-7 w-[400px] max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2 m-0">Delete Sample Group?</p>
  <p class="text-sm text-[var(--base-text-alt-dark)] leading-relaxed">
    Warning: this will also delete all samples in this group.
  </p>
  <div class="flex justify-end gap-3 mt-4">
    <button (click)="close()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
    <button (click)="deleteGroupById()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--notification-error)] text-white hover:opacity-90 transition">Delete</button>
  </div>
</div>
